var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAerotradeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 25,
    viewBox: "0 0 210 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.609 1.16785V24.3949H210V19.3666H196.536V15.4611H207.373V10.3257H196.536V6.30321H210V1.16785H191.609Z",
    fill: "url(#paint0_linear_25020_49006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.789 1.25599C158.942 1.57795 160.17 4.17263 160.324 4.49759C160.689 5.24503 161.253 5.87314 161.954 6.3098C162.654 6.74647 163.462 6.97401 164.284 6.96628C168.283 6.95528 175.326 6.95528 176.693 7.01127C178.153 7.12092 179.521 7.77687 180.53 8.85172C181.54 9.92656 182.119 11.3436 182.156 12.8275C182.13 14.3556 181.528 15.8155 180.474 16.9073C179.419 17.999 177.992 18.6398 176.486 18.6978C175.282 18.7158 171.987 18.7255 166.6 18.7268C167.396 20.5852 167.839 21.6184 167.93 21.8264C168.276 22.6108 168.84 23.2759 169.554 23.7403C170.267 24.2046 171.098 24.4482 171.945 24.4411C173.274 24.4411 174.114 24.4411 176.592 24.4301C178.732 24.4121 180.821 23.765 182.606 22.5673C184.717 21.2474 186.339 19.2583 187.222 16.9082C188.104 14.5582 188.198 11.9785 187.488 9.56895C186.731 7.14779 185.23 5.03546 183.205 3.54005C181.181 2.04464 178.738 1.24438 176.233 1.25599C175.417 1.24999 171.09 1.24899 166.949 1.24899H158.79",
    fill: "url(#paint1_linear_25020_49006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.804 10.2063C163.449 11.7088 163.804 12.542 163.869 12.706C164.218 13.4976 164.787 14.1687 165.507 14.6372C166.226 15.1057 167.065 15.3512 167.92 15.3437H173.546V10.2063H162.804Z",
    fill: "url(#paint2_linear_25020_49006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.579 7.0865H151.607L154.673 14.5666H148.408L151.579 7.0865ZM148.72 1.28722L138.704 24.3843H144.594L146.96 19.026L156.08 19.032L158.327 24.3853H164.387L154.241 1.24823C153.505 1.25223 151.665 1.26656 148.72 1.29122",
    fill: "url(#paint3_linear_25020_49006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.535 3.62465H129.535C133.2 3.62465 135.34 5.34144 135.34 8.18108V8.24608C135.34 11.2167 132.909 13.0015 129.504 13.0015H122.533L122.535 3.62465ZM120.019 1.16896V24.4001H122.536V15.3442H129.033L135.628 24.3871H138.783L131.798 14.8742C135.372 14.2093 137.97 11.9466 137.97 8.0891V8.13909C138.005 6.43966 137.375 4.79551 136.217 3.56666C134.576 2.06565 132.445 1.23426 130.235 1.23295C130.074 1.23295 129.913 1.23729 129.751 1.24595L129.762 1.16696L120.019 1.16896Z",
    fill: "url(#paint4_linear_25020_49006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.253 1.16785V3.62354H104.916V24.3949H107.538V3.62354H115.091V1.16785H97.253Z",
    fill: "url(#paint5_linear_25020_49006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5928 12.8428V12.7788C74.5928 7.51848 78.2919 3.28001 83.4818 3.28001C88.6716 3.28001 92.4349 7.57947 92.4349 12.8408V12.9098C92.4349 18.1711 88.7367 22.4086 83.5469 22.4086C78.357 22.4086 74.5938 18.1032 74.5938 12.8428M71.8579 12.4729V12.9008C71.7746 15.9794 72.9003 18.9655 74.9874 21.2026C77.0746 23.4396 79.9523 24.7445 82.9879 24.8303C83.1344 24.8343 83.281 24.8343 83.4276 24.8303C86.4922 24.8511 89.4394 23.6365 91.6211 21.4537C93.8028 19.271 95.0403 16.2987 95.0614 13.1908V12.7618C95.1444 9.68357 94.0187 6.69787 91.9318 4.46105C89.8449 2.22423 86.9676 0.919373 83.9323 0.833313L83.3812 0.833313C80.3363 0.842722 77.418 2.07049 75.2606 4.2498C73.1032 6.4291 71.8811 9.38383 71.8598 12.4719",
    fill: "url(#paint6_linear_25020_49006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0381 3.62354H59.0381C62.7028 3.62354 64.8432 5.34133 64.8432 8.17997V8.24596C64.8432 11.2166 62.4119 13.0014 59.0076 13.0014H52.0371L52.0381 3.62354ZM49.4156 1.16785V24.3949H51.9327V15.3431H58.4298L65.0246 24.3939H68.1796L61.1944 14.8811C64.7693 14.2162 67.3672 11.9535 67.3672 8.09598V8.14598C67.4015 6.44662 66.7709 4.80264 65.6132 3.57355C63.9723 2.07262 61.8414 1.24124 59.6317 1.23984C59.4706 1.23984 59.3093 1.24417 59.1476 1.25284L59.1584 1.17385L49.4156 1.16785Z",
    fill: "url(#paint7_linear_25020_49006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5248 1.28119V24.3923H44.1631V22.0476H30.1473V13.9016H42.5166V11.5529H30.1473V3.6259H43.9393V1.28119H27.5248Z",
    fill: "url(#paint8_linear_25020_49006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5224 4.07752L16.6866 15.908H6.32268L11.5224 4.07752ZM10.3521 1.0599L0 24.391H2.6107L5.30916 18.2508H17.7001L20.3621 24.391H23.1L12.7469 1.0589L10.3521 1.0599Z",
    fill: "url(#paint9_linear_25020_49006)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25020_49006",
    x1: 200.804,
    y1: 1.16785,
    x2: 200.804,
    y2: 24.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4558"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25020_49006",
    x1: 173.375,
    y1: 1.24899,
    x2: 173.375,
    y2: 24.4412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4558"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25020_49006",
    x1: 162.804,
    y1: 1.35433,
    x2: 165.356,
    y2: 25.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4558"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25020_49006",
    x1: 151.546,
    y1: 1.24823,
    x2: 151.546,
    y2: 24.3853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4558"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25020_49006",
    x1: 129.401,
    y1: 1.16696,
    x2: 129.401,
    y2: 24.4001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4558"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25020_49006",
    x1: 106.172,
    y1: 1.16785,
    x2: 106.172,
    y2: 24.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4558"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_25020_49006",
    x1: 83.4596,
    y1: 0.833313,
    x2: 83.4596,
    y2: 24.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4558"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_25020_49006",
    x1: 58.7976,
    y1: 1.16785,
    x2: 58.7976,
    y2: 24.3949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4558"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_25020_49006",
    x1: 35.8439,
    y1: 1.28119,
    x2: 35.8439,
    y2: 24.3923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4558"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_25020_49006",
    x1: 11.55,
    y1: 1.0589,
    x2: 11.55,
    y2: 24.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198FCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A4558"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAerotradeLogo);
export default __webpack_public_path__ + "static/media/AerotradeLogo.581e9fee2e09a94d1bf75fd1dcab4b82.svg";
export { ForwardRef as ReactComponent };